import { marketingAPI } from './api';

const SESSION_KEY = 'marketing_impressions_tracked';

const getTrackedSet = () => {
  try {
    const raw = sessionStorage.getItem(SESSION_KEY);
    return new Set(raw ? JSON.parse(raw) : []);
  } catch {
    return new Set();
  }
};

const persistTrackedSet = (set) => {
  try {
    sessionStorage.setItem(SESSION_KEY, JSON.stringify([...set]));
  } catch {
    // ignore
  }
};

/**
 * Track a single impression for an ad. Deduplicated per browser session.
 * Fire-and-forget: errors are swallowed.
 */
export const trackAdImpression = (adId) => {
  if (!adId) return;
  const set = getTrackedSet();
  if (set.has(adId)) return;
  set.add(adId);
  persistTrackedSet(set);
  marketingAPI.trackImpression(adId).catch(() => {});
};

/**
 * Batch-track impressions for an array of ad IDs. Deduplicated per session.
 */
export const trackAdImpressions = (adIds = []) => {
  adIds.forEach((id) => trackAdImpression(id));
};

/**
 * Track a click on an ad. Always fired (one click = one event).
 * Fire-and-forget so it does not block navigation.
 */
export const trackAdClick = (adId) => {
  if (!adId) return;
  marketingAPI.trackClick(adId).catch(() => {});
};
